export enum ErrorCode {
  MissingCountryCode = 422,
  Forbidden = 403,
}

export enum AuthErrorCode {
  SessionExpired = "AUA001",
  EmptyGroup = "AUV001",
}

export enum AuthInstagramIntegrationCode {
  Connect = "AUI001",
  Reconnect = "AUI002",
  Disconnect = "AUI003",
}
